import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { X } from "lucide-react";

export const DeleteConfirmationModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: "0.75rem",
        },
      }}>
      <DialogTitle className="flex justify-between items-center border-b px-6 py-4">
        <Typography
          variant="h6"
          className="font-outfit font-semibold text-gray-800">
          Delete Unit
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          className="text-gray-500 hover:text-gray-700">
          <X className="w-5 h-5" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="p-6">
        <Typography className="text-gray-600">
          Are you sure you want to delete this unit? This action cannot be
          undone.
        </Typography>
      </DialogContent>
      <DialogActions className="border-t p-4 gap-2">
        <Button
          onClick={onClose}
          variant="outlined"
          className="text-gray-700 border-gray-300 hover:bg-gray-50">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          className="bg-red-600 hover:bg-red-700">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
